import React from 'react';
import Image from 'next/image';

const BuildIntelligence = () => {
    return (
        <div
            className="section-py dark:text-light border-b"
            style={{
                borderImageSource: 'linear-gradient(270deg, rgba(60, 69, 97, 0) 0%, #3C4561 50%, rgba(60, 69, 97, 0) 100%)',
                borderImageSlice: 1,
            }}>
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-6">
                        <h2 className="mb-2.5 dark:text-white"
                        data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                            Build Intelligence That Sees: Vision AI & Multimodal AI
                        </h2>  
                        <p className="dark:text-[#D7DEE5] mb-0"
                        data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                            Transform raw visual data into actionable business intelligence with production-ready computer vision and multimodal AI systems. From quality inspection to document intelligence, we deliver custom vision solutions that integrate seamlessly with your enterprise workflows - fast POCs, secure deployment, and measurable ROI.
                        </p>                      
                    </div>
                    <div className="lg:col-span-6">
                                            <div className="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-2 gap-7 mb-7">
                                                <div className="flex flex-col gap-[9px] card p-5 bg-white rounded-10 border dark:border-[#ffffff33] dark:border-solid dark:bg-[#3C45611A]"
                                                data-aos="fade-up"
                                                data-aos-duration="700"
                                                data-aos-delay="200">
                                                    <div className="voice-generator-box">
                                                        <Image
                                                            src="/img/vision-and-multimodal-ai/svg/ic-real-time-object-detection.svg"
                                                            width={36}
                                                            height={36}
                                                            alt="safe-productive"
                                                        />
                                                    </div>
                    
                                                    <p className="fs-md mb-0 dark:text-[#D7DEE5]">
                                                        Real-time object detection, classification, and tracking for manufacturing, retail, and security
                                                    </p>
                                                </div>
                                                <div className="flex flex-col gap-[9px] card p-5 bg-white rounded-10 border dark:border-[#ffffff33] dark:border-solid dark:bg-[#3C45611A]"
                                                data-aos="fade-up"
                                                data-aos-duration="700"
                                                data-aos-delay="200">
                                                    <div className="voice-generator-box">
                                                        <Image
                                                            src="/img/vision-and-multimodal-ai/svg/ic-multimodal-ai.svg"
                                                            width={36}
                                                            height={36}
                                                            alt="Orchestrated agents"
                                                        />
                                                    </div>
                    
                                                    <p className="fs-md mb-0 dark:text-[#D7DEE5]">
                                                        Multimodal AI combining vision, text, and sensor data for richer contextual understanding
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1">
                                                <div className="flex flex-col gap-[9px] card p-5 bg-white rounded-10 border dark:border-[#ffffff33] dark:border-solid dark:bg-[#3C45611A]"
                                                data-aos="fade-up"
                                                data-aos-duration="700"
                                                data-aos-delay="200">
                                                    <div className="voice-generator-box">
                                                        <Image
                                                            src="/img/vision-and-multimodal-ai/svg/ic-enterprise-grade-deployment.svg"
                                                            width={36}
                                                            height={36}
                                                            alt="MCP-powered controls"
                                                        />
                                                    </div>
                                                    <p className="fs-md mb-0 dark:text-[#D7DEE5]">
                                                        Enterprise-grade deployment with MLOps pipelines, edge optimization, and compliance-ready governance
                                                    </p>
                                                </div>
                                                
                                            </div>
                                        </div>
                </div>
            </div>
        </div>
    );
};

export default BuildIntelligence;
